import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#2F2B36",
      contrastText: "#fff",
    },
    secondary: {
      main: "#8ED2C9",
      contrastText: "#2F2B36",
    },
    background: {
      default: "#F7F7F7",
    },
    text: {
      primary: "#2F2B36",
    },
  },
  typography: {
    fontFamily: "\"Wix Madefor Text\", Arial, sans-serif",
  },
});

export default theme;
